module.exports = __webpack_public_path__ + "static/media/clusterIcon.a1dbf9c7.svg";